import React, { useEffect, useState, useMemo } from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { useSelector } from 'react-redux';
import DateFormat, { MonthName, monthNames, monthNamesShort } from 'utils/dateFormat';
import Spinner from '../common/Spinner';
import Maybe from '../common/Maybe';
import useDashboardMetrics from 'hooks/useDashboardMetrics';
import CurrencyFormat from 'utils/currencyFormat';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const InflowOutflowChart = ({ chartData, loading, selectedInflowOutflowFilter }) => {
    // const currentMonth = new Date().getMonth();
    // const filteredChartData = chartData?.filter((_, index) => index <= currentMonth);
    // const labels = monthNamesShort.slice(0, currentMonth + 1).map(el => el.toUpperCase());
    const sortedData = useMemo(() => {
        let data = []; 
        if (selectedInflowOutflowFilter === "weekly") {
            data = chartData?.sort((a, b) => new Date(a.period) - new Date(b.period));
        } else {
            data = chartData?.sort((a, b) => monthNamesShort.indexOf(a.period) - monthNamesShort.indexOf(b.period)); 
        }
        
        return data;
    }, [chartData, selectedInflowOutflowFilter]);


    const options = {
        plugins: {
            title: {
            display: true,
            },
        legend: {
            display: false,
                labels: {
                    boxWidth: 8,
                    boxHeight: 8,
                }
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: false,
                grid: { display: false },
            },

            y: {
                stacked: false,
                ticks: {
                    display: true,
                },
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                    borderDash: [5, 5],
                    // display: false
                    drawBorder: false
                }
            },
        },
    };

    const data = {
        labels: sortedData?.map(item => {
            let label;
            if (selectedInflowOutflowFilter === "weekly") {
                label = DateFormat(item.period, "DD-MM");
            } else if (selectedInflowOutflowFilter === "monthly") {
                label = `Week ${item.period}`
            } else {
                label = item.period;
            }
            
            return label;
        }),
        datasets: [
        {
            label: 'Inflow',
            data: sortedData?.map((item) => item?.creditAmount / 100),
            backgroundColor: '#398D94',
            borderRadius: 6,
            barThickness: 10,
        },
        {
            label: 'Outflow',
            data: sortedData?.map((item) => item?.debitAmount / 100),
            backgroundColor: '#E5E7EB',
            hoverBackgroundColor: '#E5E7EB',
            borderRadius: 6,
            barThickness: 10,
        },
        ],
    };

    return (
        <>
            <Maybe condition={loading}>
                <Spinner />
            </Maybe>

            <Maybe condition={!loading}>
                <div className="w-full flex items-center flex-wrap lg:flex-nowrap" style={{height: "250px"}}>
                    <Bar options={options} data={data} />
                </div>
            </Maybe>
        </>
        )
}

export default InflowOutflowChart